import getConfig from 'next/config';

/**
 * @param rootNodeId
 * @param rootNodeType
 * @param language
 * @returns {Promise<GuidedSearchResultApiProps>}
 */
const get = (rootNodeId, rootNodeType, language) => {
  const { publicRuntimeConfig } = getConfig();

  /**
   * @type {GuidedSearchApiHeaders}
   */
  const headers = {
    Accept: 'application/json',
    'Accept-Language': language,
  };

  return fetch(
    `${publicRuntimeConfig.guidedSearchBaseUrl}/${rootNodeId}?type=${rootNodeType}`,
    {
      headers,
    },
  ).then((res) => {
    return res.json();
  });
};

export default {
  get,
};
